import { Col, Form } from "react-bootstrap";

function ContentBox({ register, errors, index, content }) {
  return (
    <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
      <Form.Label>محتویات:</Form.Label>
      <Form.Control
        {...register(`items.${index}.content`, {
          required: { value: true, message: "محتویات الزامی" },
          value: content,
        })}
        placeholder="مثل: کیف"
      />
      {errors?.content && <p>{errors?.content?.message}</p>}
    </Col>
  );
}

export default ContentBox;
